import React from 'react';
import styles from './ResizeHandle.module.css';
import { ResizablePane } from './useResizablePane';

type ResizeHandleProps = {
  pane: ResizablePane;
  /** Overrides the generic "Resize panel" label for screen readers. */
  label?: string;
};

/**
 * Drag handle for a resizable side pane. Render it as the first child of the
 * pane.
 *
 * Deliberately a <span>, not a <div>: ImprovementPlanView styles its panes with
 * `.tasksRight > div { position: static !important }` to tame a nested
 * component, which would otherwise strip this handle's positioning.
 *
 * It is `position: sticky` with zero height so it occupies no layout space and
 * stays in view while the pane's content scrolls underneath; the grabbable area
 * and the visible line both come from pseudo-elements.
 */
const ResizeHandle = ({ pane, label }: ResizeHandleProps) => (
  <span
    {...pane.separatorProps}
    aria-label={label ?? pane.separatorProps['aria-label']}
    className={`${styles.handle} ${pane.isResizing ? styles.active : ''}`}
  />
);

export default ResizeHandle;
